import { useState, useRef, useEffect } from "react";

const SearchableSelect = ({ list, formData, handleChange, name, placeholder }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (formData[name] && !list?.result?.some((opt) => opt.id === formData[name])) {
      handleChange({ target: { name: name, value: null } });
    }
  }, [list, formData, name]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredOptions = list?.result?.filter((option) =>
    option.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
  };

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <div
        className="w-full p-1 border-2 rounded cursor-pointer bg-white"
        onClick={toggleDropdown}
      >
        {formData[name] && list?.result?.some((opt) => opt.id === formData[name])
          ? list?.result?.find((opt) => opt.id === formData[name])?.title
          : placeholder}
      </div>
      {isOpen && (
        <div className="absolute z-10 w-full bg-white rounded shadow-md mt-1">
          <input
            ref={inputRef}
            type="text"
            className="w-full p-2 border-b outline-none"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="max-h-40 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <div
                  key={option.id}
                  className="p-2 hover:bg-gray-200 cursor-pointer"
                  onClick={() => {
                    handleChange({ target: { name: name, value: option.id } });
                    setIsOpen(false);
                  }}
                >
                  {option.title}
                </div>
              ))
            ) : (
              <div className="p-2 text-gray-500">No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
